export interface ICreateConsultationPayload {  email: string;
    firstName: string;
    lastName: string;
    phone: string;
    date: Date;
    time: string;
    message: string;
    type: consultationType;
    consultationStatus: consultationStatus;
}

export enum internalStatus { // Renamed the enum for clarity
  PENDING = "PENDING",
  CANCELED = "CANCELED",
  INPROGRESS = "INPROGRESS",
  COMPLETED="COMPLETED"
}
export interface IConsultation{
  _id:string;
  email:string;
  firstName: string;
  lastName: string;
  phone: string;
  date: Date;
  time: string;
  message: string;
  type: consultationType;
  consultationStatus: consultationStatus;
  createdAt:Date,
  status:internalStatus
}
export interface IEmailConfirmation{
  consultationId:string,
  userId:string,
  reminders: string[],
  firstName: string,
  lastName: string,
  appointments:string[],
  description: string,
  email:string
  consultationStatus:consultationStatus,
  status:internalStatus
}
export interface Email{
  id:string;
  description:string;
  appointments:string[],
  reminders:string[]
}

export enum consultationType {
    PHYSICAL = "Physical",
    VIRTUAL = "Virtual"
  }
  
  export enum consultationStatus {
    PENDING = "Pending",
    COMPLETED = "Completed",
    SCHEDULED = "Scheduled",
    RESCHEDULED = "Rescheduled"
  }
  
  export interface ConsultFormValues {
    consultationId:string;
    email: string;
    firstName: string;
    lastName: string;
    description: string;
    appointments: string[];
    reminders: string[];
    newAppointment: string;
    newReminder: string;
  }